type VisibilityCallback = (visible: boolean) => void;

class OverlaySpinnerService {
  private visibilityCallback: VisibilityCallback | null = null;
  private activeCalls = 0; // Counter to track active calls

  register(callback: VisibilityCallback) {
    this.visibilityCallback = callback;
  }

  unregister() {
    this.visibilityCallback = null;
  }

  show() {
    this.activeCalls++;
    if (this.activeCalls === 1 && this.visibilityCallback) {
      this.visibilityCallback(true);
    }
  }

  hide() {
    if (this.activeCalls > 0) {
      this.activeCalls--;
      if (this.activeCalls === 0 && this.visibilityCallback) {
        this.visibilityCallback(false);
      }
    }
  }

  isVisible() {
    return this.activeCalls > 0;
  }
}

export const overlaySpinnerService = new OverlaySpinnerService();
